import React, { Fragment } from 'react'
import Divider from 'components/Divider'
import { Radio, Select } from 'components/forms/'
import { RadioGroup } from 'informed'
import { listCashRegisters } from 'gql/query'

const FilterComponent = ({ clearFilter, t }) => (
	<Fragment>
		<Divider visible height={20}/>
		<RadioGroup field='isActive'>
			<Radio label={t('user_section.fields.all_users')}/>
			<Radio value={true} label={t('user_section.fields.active_users')}/>
			<Radio value={false} label={t('user_section.fields.incative_users')}/>
		</RadioGroup>
		<Divider height={20}/>
		<Select
			field='cashRegisterId'
			valueField='id'
			labelField='name'
			isClearable
			removeOnClear
			remoteOptions={{ query: listCashRegisters, variables: { params: { limit: 100 } } }}
			isSearchable
			withVirtualBody
			label={t('common.fields.cash_register')}
		/>
	</Fragment>
)

export default FilterComponent
